import { injectRefreshFunc, injectStore as injectStoreNew } from "app/api";
import settings from "app/settings";
import { persistor, store } from "app/store";
import createTheme from "app/theme";
import { AppRoot, bootstrap, GlobalFilePreview } from "common";
import { refreshAsync } from "features/identity/identitySlice";
import "material-icons/iconfont/material-icons.css";
import "moment/locale/hu";
import ReactDOM from "react-dom/client";
import { injectStore } from "utils/api";
import { injectStore as injectStoreAuthRules } from "utils/authRules";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
//Bootstrap app settings
bootstrap(settings);

injectStoreNew(store);
injectStoreAuthRules(store);
injectStore(store);
injectRefreshFunc(refreshAsync);

// Grid hack
console.error = (function () {
  var error = console.error;

  return function (exception: any) {
    if (
      typeof exception === "string" &&
      exception.indexOf("License key not found") === -1 &&
      exception.indexOf("UNSAFE_componentWillReceiveProps") === -1
    ) {
      // @ts-ignore
      error.apply(console, arguments);
    }
  };
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  /*<React.StrictMode>*/
  <AppRoot createTheme={createTheme} store={store} persistor={persistor}>
    <App />
    <GlobalFilePreview />
  </AppRoot>
  /*</React.StrictMode>*/
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
